import {context} from '../../../props/context'
export default {
  name: 're-group-box',
  props: {
    title: {},
    context,
    titleContainerClasses: {},
    contentContainerClasses: {},
    actionsContainerClasses: {},
  },
  data() {
    return {}
  }
}
